import React from 'react'
import { Typogaphy } from 'vnetwork-ui'

interface SectionHeaderProps {
    title: string
    icon: React.ReactNode
    step?: number
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, icon, step }) => (
    <div className="flex items-center gap-3 mb-4">
        {step && (
            <div className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center text-sm font-medium">
                {step}
            </div>
        )}
        <div className="flex items-center gap-2 text-gray-700">
            {icon}
            <Typogaphy className="font-medium text-base">{title}</Typogaphy>
        </div>
    </div>
)

export default SectionHeader
